import styled, { css } from "styled-components";
import tokens from "../../theme/tokens";

const sizeStyles = {
  sm: css`
    font-size: 11px;
    padding: 3px 9px;
    height: 20px;
  `,
  md: css`
    font-size: 12px;
    padding: 5px 11px;
    height: 24px;
  `,
};

export const TagRoot = styled.span`
  display: inline-flex;
  align-items: center;
  max-width: 220px;
  border: 1px solid ${tokens.status.neutral.border};
  background: ${tokens.status.neutral.bg};
  color: ${tokens.status.neutral.fg};
  border-radius: 9999px;
  font-family: ${tokens.typography.fontFamily};
  font-weight: ${tokens.typography.weight.medium};
  line-height: 1;

  ${(p) => sizeStyles[p.$size] || sizeStyles.sm}
`;

/**
 * text-overflow: ellipsis has no effect on inline-flex boxes, so the
 * truncation styles live on an inline-block child. This also leaves room
 * for a future icon slot inside TagRoot without the icon getting truncated.
 */
export const TagLabel = styled.span`
  display: inline-block;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const EmptyText = styled.span`
  color: ${tokens.text.disabled};
  font-family: ${tokens.typography.fontFamily};
  font-size: 13px;
`;
